import { Box, Typography } from '@mui/material';
import type { FC } from 'react';
import React from 'react';

const Info: FC<{ label: string; value: string }> = ({ label, value }) => {
  return (
    <Box>
      <Typography
        sx={{
          color: '#8B8B8B',
          fontSize: '0.9rem',
          mb: '0.25rem',
        }}
      >
        {label}
      </Typography>
      <Typography
        sx={{
          fontWeight: 500,
          letterSpacing: '0.096rem',
        }}
      >
        {value}
      </Typography>
    </Box>
  );
};

export default Info;
